import React from "react";
import { useParams } from "react-router-dom";
import UnitTypeThemeProvider from "core/UnitTypeThemeProvider";
import TastingResultScreen from "screens/unit-result/tasting/TastingResultScreen";
import { END_TASTING_EXECUTION_FLOW } from "consts";
import { useEntity, useFlow } from "student-front-commons/src/hooks";
import { UNIT_SCHEMA } from "student-front-commons/src/schemas";

function TastingResultScreenContainer() {
  const params = useParams();

  const unit = useEntity(UNIT_SCHEMA, params.unitId);

  const [isPending] = useFlow(END_TASTING_EXECUTION_FLOW, {
    autoStart: true,
    params: {
      unit: params.unitId,
    },
  });

  return (
    <UnitTypeThemeProvider unitType={unit?.type}>
      <TastingResultScreen isLoading={isPending} />
    </UnitTypeThemeProvider>
  );
}

export default TastingResultScreenContainer;
